import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import { getWidth } from './utils'

const StyledPicture = styled.img`
	height: 100%;
	width: 100%;
	margin-bottom: 1.45rem;
    background: #F7F7F7;
`
    // min-height: ${props => {
    // 	const width = getWidth(props.layout)
    // 	const imagesPerLine = props.layout === 'zweier' ? 2 : props.layout === 'dreier' ? 3 : 1
    // 	return props.orientation === 'portrait' ? 1.2 * width / imagesPerLine - 4 : width / 2
    // }}%;

export default class Picture extends React.Component {
	render(){
		const size = 
			this.props.size === 'cover' ? {
				small: {
					url: 'w_230,h_230',
					srcset: '230w'
				},
				medium: {
					url: 'w_380,h_380',
					srcset: '380w'
				},
				large: {
					url: 'w_500,h_500',
					srcset: '500w'
				}
			} : this.props.size === 'project' ? {
				small: {
					url: 'w_1100',
					srcset: '1100w'
				},
				medium: {
					url: 'w_1500',
					srcset: '1500w'
				},
				large: {
					url: 'w_2000',
					srcset: '2000w'
				}
			} : {}
		return(
			<StyledPicture
				layout={this.props.layout}
				srcSet={`
						https://res.cloudinary.com/katjakrug/image/upload/f_auto,${size.small.url}/${this.props.imagecode} ${size.small.srcset},
				      	https://res.cloudinary.com/katjakrug/image/upload/f_auto,${size.medium.url}/${this.props.imagecode} ${size.medium.srcset},
				      	https://res.cloudinary.com/katjakrug/image/upload/f_auto,${size.large.url}/${this.props.imagecode} ${size.large.srcset}
				`}
				sizes={this.props.sizes}
				src={`https://res.cloudinary.com/katjakrug/image/upload/f_auto,${size.small.url}/${this.props.imagecode}`}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Picture.js